import AvatarBadgeGroup from './AvatarBadgeGroup'

export default AvatarBadgeGroup
